import { render, staticRenderFns } from "./HeadRefresh.vue?vue&type=template&id=5d0671ad&scoped=true&"
import script from "./HeadRefresh.vue?vue&type=script&setup=true&lang=js&"
export * from "./HeadRefresh.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HeadRefresh.vue?vue&type=style&index=0&id=5d0671ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0671ad",
  null
  
)

export default component.exports